// extracted by mini-css-extract-plugin
export default {"url-arrow":"InputURL_url-arrow__QL++e"};